import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

class LabelledSwitch extends React.Component {

    handleChange = event => this.props.handleChange(event.target.checked);

    render() {

        const { classes, checked, label, disabled, isReadOnly, dataTest, margin } = this.props;

        return (
            <div data-test={dataTest} style={{
                marginTop: margin ? '10px' : '0px',
                marginBottom: margin ? '10px' : '0px',
                paddingLeft: '10px'
            }}>
                <FormControlLabel
                    data-test="toggle-control"
                    style={{
                        ...(!margin) && { marginRight: '0px' }
                    }}
                    classes={{
                        label: classes.formLabel
                    }}
                    control={
                        <Switch
                            data-test="toggle-switch"
                            inputProps={{
                                "data-test": dataTest + "-toggle"
                            }}
                            checked={checked}
                            disabled={disabled}
                            onChange={isReadOnly ? null : (e) => this.handleChange(e)}
                            color="primary"
                        />
                    }
                    label={label}
                />
            </div>
        );
    }
}

LabelledSwitch.defaultProps = {
    checked: false,
    margin: true,
    invalid: false,
    disabled: false,
    isReadOnly: false
};

LabelledSwitch.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    label: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    checked: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(LabelledSwitch);